import fetchOrder from '../Services/fetchOrder';

export default () => async (dispatch) => {
  dispatch(fetchOrder());
}